import React, { useState } from "react";
import ProgressBar from "Components/shared/progressbar";
import styles from "./transfer.module.css";
import { useNavigate } from "react-router-dom";
import { HeaderItem, StageHeader, Stages } from "Components/shared/progress";
import {
  SelectBeneficiary,
  Summary,
} from "Components/main_components/transfer/saved_beneficiary";
import Modal from "Components/shared/modal";
import Text from "Components/shared/text";
import AuthCodeInput from "Components/main_components/registeration/AuthCodeInput";
import Button from "Components/shared/button";
import {
  PinInput,
  TransactionEnd,
} from "Components/main_components/transfer/reusables";
import Hidden from "Components/shared/hidden";
import Back from "Components/main_components/registeration/Back";
import useForm from "hooks/useForm";
import { useGetWalletBalance } from "services/walletService";
import { useAuthStore } from "providers/auth";
import { handleSendToBeneficiary, useGetBeneficiaries } from "services/transferService";

const Beneficiary = () => {
  const totalStages = 2;
  const navigate = useNavigate();
  

  const [stage, setStage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const {data: beneficiaries} = useGetBeneficiaries();
  const handleNext = () => {
    if (!(stage < totalStages)) return;
    setStage(stage + 1);
  };
  const handlePrev = () => {
    if (!(stage > 1)) return;
    setStage(stage - 1);
  };
  const handleComplete = () => {
    setOpenModal(true);
  };
  
  const confirmHandler = async(pin, func) => {
    let replace = `[$₦€\,]+`;
    let re = new RegExp(replace,"g");
    //Make request and then call success popup
    const {data, status} = await handleSendToBeneficiary(values.beneficiary, values.amount.replace(re, ""),pin); 
    if(status == "Ok"){
      setOpenModal(false);
      setConfirmModal(true);
      func?.();
    }
    console.log(data, "DTA")
   
  };
  const onSuccessHandler = () => {
    setConfirmModal(false);
    navigate("/transfer/transfer-history");
  };
  
  //Form Related States
  const initialState = {
    accountType: "Naira",
    beneficiary: "",
    amount: "",
    remark: ""
  };
  const submitHandler = (values, errors, setSubmitting, setErrors) => {};
  const {
    handleSubmit,
    values,
    errors,
    isSubmitting,
    isValid,
    touched,
    handleUpdate,
  } = useForm({initialState, onSubmitHandler: submitHandler});
  const receiver = beneficiaries?.find(benefit => benefit.beneficiaryId === values.beneficiary) || {}
  const {profile} = useAuthStore();
 
  return (
    <div className={styles.Beneficiary}>
      <form onSubmit={handleSubmit}>
        <StageHeader
          currentStage={stage}
          totalStages={totalStages}
          className={styles.StageHeader}
          left={
            stage == 2 ? (
              <Hidden smDown>
                <Back onClick={handlePrev} />
              </Hidden>
            ) : null
          }
        >
          <HeaderItem active={stage === 1} passed={stage > 1}>
            Select Beneficiary
          </HeaderItem>
          <HeaderItem active={stage === 2} passed={stage > 2}>
            Summary
          </HeaderItem>
        </StageHeader>
        <Stages
          active={stage}
          values={values}
          handleUpdate={handleUpdate}
          errors={errors}
          touched={touched}
          isSubmitting={isSubmitting}
          isValid={isValid}
        >
          <SelectBeneficiary
            onNext={handleNext}
            onPrevious={() => navigate("../")}
          />
          <Summary onNext={handleComplete} onPrevious={handlePrev} />
        </Stages>
      </form>
     { stage >= 2 && <PinInput
        onCancel={() => setOpenModal(false)}
        onConfirm={confirmHandler}
        openModal={openModal}
        onClose={() => setOpenModal(false)}
      />}
      <TransactionEnd
        openModal={confirmModal}
        onClose={() => setConfirmModal(false)}
        onSuccess={onSuccessHandler}
        onError={() => {}}
        data={{
          "Recipient name": receiver.accountName,
          "Recipient account": receiver.accountNumber,
          "Recipient Bank": receiver.bank,
          Amount: values.amount,
          From: `${profile.firstName} ${profile.lastName}` ,
        }}
      />
    </div>
  );
};

export default Beneficiary;
